import * as React from 'react';

import Layout from 'components/layout';

import './src/styles/global/index.scss';

// eslint-disable-next-line react/jsx-filename-extension,import/prefer-default-export
export const wrapPageElement = ({ element, props }) => <Layout {...props}>{element}</Layout>;
